import styled from "styled-components";

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 640px;
  font-family: "Geist", sans-serif;
  color: #181d27;

  .panel-heading {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.2px;
  }

  .panel-subtitle {
    margin: 0;
    padding-top: 4px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
  }

  .documents-table {
    margin-top: 16px;
    border: 0.909px solid rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    overflow: hidden;
  }

  .documents-head,
  .documents-row {
    display: grid;
    grid-template-columns: minmax(120px, 1fr) minmax(0, 1.6fr) 118px;
    align-items: center;
    gap: 12px;
    padding: 0 16px;
  }

  .documents-head {
    height: 43px;
    border-bottom: 0.909px solid rgba(0, 0, 0, 0.06);
    background: #fafafa;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.1px;
    color: #535861;
  }

  .documents-head .download-col {
    text-align: right;
  }

  .documents-row {
    min-height: 63px;
    border-bottom: 0.909px solid rgba(0, 0, 0, 0.06);
  }

  .documents-row:last-child {
    border-bottom: none;
  }

  .doc-date {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #181d27;
  }

  .doc-type {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    color: #535861;
  }

  .doc-type-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .doc-type-label {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #181d27;
  }

  .doc-type-detail {
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.1px;
    color: #535861;
    overflow-wrap: anywhere;
  }

  .doc-download {
    display: flex;
    justify-content: flex-end;
  }

  .documents-state {
    padding: 32px 16px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: #535861;
  }

  .documents-state .retry {
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    color: #181d27;
    text-decoration: underline;
    cursor: pointer;
  }

  .show-more {
    display: flex;
    justify-content: center;
    padding-top: 16px;
  }

  @media (max-width: 768px) {
    .documents-head {
      display: none;
    }

    .documents-row {
      grid-template-columns: 1fr auto;
      grid-template-areas: "type download" "date download";
      gap: 4px 12px;
      padding: 12px 16px;
    }

    .doc-type {
      grid-area: type;
    }

    .doc-date {
      grid-area: date;
      color: #535861;
      font-size: 12px;
    }

    .doc-download {
      grid-area: download;
    }
  }
`;

export const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 8px 14px;
  border: 0.909px solid rgba(0, 0, 0, 0.09);
  border-radius: 8px;
  background: #fff;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: rgba(10, 13, 18, 0.7);
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: #fafafa;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  &:focus-visible {
    outline: 2px solid #181d27;
    outline-offset: 2px;
  }
`;

export const MoreButton = styled(DownloadButton)`
  color: #181d27;
`;
